import { IconButton, makeStyles, TableCell, TableRow, Tooltip } from "@material-ui/core";
import { DeleteOutline } from "@material-ui/icons";
import { useLocation } from "react-router-dom";
import { TableColumnTypes } from "../../Enums/TableColumnTypes";
import { deleteMergeIntegration } from "../../Services/API/BaseClientManagement";

const useStyles = makeStyles((theme) => ({
  rowCell: {
    cursor: "pointer",
    background: theme.palette.primary.blue,
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  rowCellOdd: {
    cursor: "pointer",
    background: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
}));

export default function MergeLinkTableCell({ columns, element, index }) {
  const classes = useStyles();

  const handleCellClick = (integrationId) => {
    window.open(`https://app.merge.dev/linked-accounts/account/${integrationId}`, "_blank");
  };

  const getCellContent = (column) => {
    switch (column.type) {
      case TableColumnTypes.Date:
        return new Date(element[column.propName]).toLocaleString("en-US");
      default:
        return element[column.propName];
    }
  };

  return (
    <Tooltip title="View Account In Merge" placement="right">
      <TableRow
        className={index % 2 ? classes.rowCell : classes.rowCellOdd}
        key={index}
        data-test={`mergeintegration-tablerow-${element.id}`}
      >
        {columns.map((column, elementIndex) => (
          <TableCell align="left" key={elementIndex} onClick={() => handleCellClick(element.id)}>
            {getCellContent(column)}
          </TableCell>
        ))}
      </TableRow>
    </Tooltip>
  );
}
